import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 7\" id=\"arrow-down\"><path d=\"M1 1l4 4 4-4\" fill=\"none\" stroke=\"#A4A4AE\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id